import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useAdvisors } from "../../context/useAdvisorsContext";

const PINK = "#F8296A";
const CARD_BG = "#0a0b25";

const Stars = () => (
  <div className="d-flex gap-1 mb-3">
    {Array.from({ length: 5 }).map((_, i) => (
      <svg
        key={i}
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill={PINK}
      >
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
      </svg>
    ))}
  </div>
);

const buildWhatsappUrl = (whatsapp) => {
  if (!whatsapp) return "#";
  const digits = String(whatsapp).replace(/\D/g, "");
  return `https://wa.me/${digits}`;
};

const AdvisorCard = ({ advisor, showHeading, index = 0 }) => {
  const role = "Asesora verificada Tu Carro por America";
  const firstName = advisor.name?.split(" ")[0] || "";
  const gradientAngle = index % 2 === 0 ? "90deg" : "270deg";

  return (
    <div
      className="w-100 py-5"
      style={{
        background: `linear-gradient(${gradientAngle}, rgba(233,110,148,0.2) 0%, rgba(4,2,29,0) 100%)`,
      }}
    >
      <Container style={{ maxWidth: "720px" }}>
        {showHeading && (
          <h2
            className="text-font text-white text-center fw-bold mb-5"
            style={{
              fontSize: "clamp(1.75rem, 3.5vw, 2.5rem)",
              letterSpacing: "0.02em",
            }}
          >
            NUESTROS ASESORES
          </h2>
        )}
        <Row className="g-3 align-items-stretch justify-content-center">
          <Col xs={12} sm={6} md={6}>
            <div
              className="rounded-4 overflow-hidden w-100"
              style={{
                background: "#ffffff",
                aspectRatio: "4 / 5",
              }}
            >
              <img
                src={advisor.photoUrl}
                alt={advisor.name}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  display: "block",
                }}
              />
            </div>
          </Col>
          <Col xs={12} sm={6} md={6}>
            <div
              className="rounded-4 py-4 px-5 d-flex flex-column w-100 advisor-desc-card"
              style={{
                background: CARD_BG,
                overflow: "hidden",
              }}
            >
              <Stars />
              <h3
                className="text-font text-white fw-bold mb-1"
                style={{ fontSize: "clamp(1.625rem, 2.86vw, 2.08rem)" }}
              >
                {advisor.name}
              </h3>
              <p
                className="text-font mb-3 fw-bold"
                style={{ color: PINK, fontSize: "0.91rem" }}
              >
                {role}
              </p>
              <p
                className="text-font text-white mb-0"
                style={{
                  fontSize: "1.3rem",
                  lineHeight: "1.45em",
                  opacity: 0.9,
                  fontWeight: 300,
                }}
              >
                {advisor.description_es}
              </p>
            </div>
          </Col>
        </Row>

        {advisor.tags?.length > 0 && (
          <div className="d-flex flex-wrap gap-2 justify-content-center mt-4">
            {advisor.tags.map((tag, i) => (
              <span
                key={i}
                className="rounded-2 px-3 py-2"
                style={{
                  fontSize: "0.975rem",
                  fontWeight: 400,
                  border: i === 0 ? "none" : "1px solid #BFDCFE",
                  background: i === 0 ? "#FFCBD6" : "transparent",
                  color: i === 0 ? "#04021D" : "#ffffff",
                }}
              >
                {tag.name_es}
              </span>
            ))}
          </div>
        )}

        <div className="d-flex justify-content-center mt-3">
          <a
            href={buildWhatsappUrl(advisor.whatsapp)}
            target="_blank"
            rel="noopener noreferrer"
            className="d-block text-center text-no-dec text-white text-font fw-bold rounded-2 py-3 px-5"
            style={{
              background: PINK,
              textDecoration: "none",
              fontSize: "1.17rem",
              letterSpacing: "0.02em",
              minWidth: "280px",
            }}
          >
            HABLAR CON {firstName.toUpperCase()} AHORA
          </a>
        </div>
      </Container>
    </div>
  );
};

const NuestrosAsesores = () => {
  const { data: advisors, isLoading, error } = useAdvisors();

  return (
    <section id="asesores" className="bg-navbar">
      {isLoading && (
        <p className="text-font text-white text-center py-5">
          Cargando asesores...
        </p>
      )}

      {!isLoading &&
        !error &&
        advisors?.map((advisor, i) => (
          <AdvisorCard
            key={advisor.id}
            advisor={advisor}
            index={i}
            showHeading={i === 0}
          />
        ))}
    </section>
  );
};

export default NuestrosAsesores;
